/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/sheets/QaPhoneSelectQaSheet.tsx
 * FILE_ID: JOBHUB-QA-PHONE-SELECT-QA-001
 * PURPOSE: Phone sheet that picks which QA record is open.
 */
import { MobileSheet } from '@quotech/ui'
import { requestQaPhoneInspection } from '../../../../qa/phonePage'
import { JobQaInspectionSection } from '../../JobQaInspectionSection'
import type { JobQaTabController } from '../../useJobQaTabController'

export function QaPhoneSelectQaSheet({
  open,
  onClose,
  controller,
}: {
  open: boolean
  onClose: () => void
  controller: JobQaTabController
}) {
  return (
    <MobileSheet open={open} onClose={onClose} title="Select QA">
      {/* Reused from: packages/job-hub/src/jobs/tabs/job-qa/JobQaInspectionSection.tsx (JobQaInspectionSection) */}
      <JobQaInspectionSection
        workspace={controller.workspace}
        jobId={controller.props.jobId}
        orgId={controller.props.orgId}
        quotes={controller.props.quotes}
        onPicked={(pickedId) => {
          onClose()
          requestQaPhoneInspection(pickedId)
        }}
      />
    </MobileSheet>
  )
}
